

export const  areAllAnswersProvided = (quizAnswers) => {
    for (let i = 0; i < quizAnswers.length; i++) {
      const options = quizAnswers[i];
      if (options.length === 0) {
        return false;
      }
    }
    return true;
  }